import { useState, useCallback } from "react";
import { router } from "expo-router";
import PaymentMethodServices from "@/services/paymentMethodServices";

const usePaymentMethodCheck = () => {
  const [isChecking, setIsChecking] = useState(false);
  const [hasPaymentMethod, setHasPaymentMethod] = useState<boolean | null>(
    null
  );

  const checkPaymentMethod = useCallback(
    async (redirectUrl: string, offerAmount?: number) => {
      setIsChecking(true);
      try {
        const paymentMethods = await PaymentMethodServices.getPaymentMethods();
        const hasPaymentMethod = paymentMethods && paymentMethods.length > 0;
        setHasPaymentMethod(hasPaymentMethod);

        if (!hasPaymentMethod) {
          let url = `/payment/register-method?redirectUrl=${encodeURIComponent(
            redirectUrl
          )}`;
          if (offerAmount !== undefined) {
            url += `&amount=${offerAmount}`;
          }
          router.push(url as any);
        }

        return hasPaymentMethod;
      } catch (error) {
        console.error("Error checking payment methods:", error);
        setHasPaymentMethod(false);
        return false;
      } finally {
        setIsChecking(false);
      }
    },
    []
  );

  return {
    isChecking,
    hasPaymentMethod,
    checkPaymentMethod,
  };
};

export default usePaymentMethodCheck;
